import api from "../../../api";
import urls from "../../../urls";

export async function validateToken(token: string, uid: string) {
  await api.publicRequest("POST", urls.auth.validateToken(), {
    token,
    uid
  });
}
